import * as React from 'react';
import { useSelector } from 'react-redux';

import { useIsFirstRun } from '@cian/valuation-utils-component';

import { getEstimationFiltersHash } from '../../../selectors/estimation';
import { selectDealType } from '../../../selectors/page';
import { scrollingContext } from '../../Scrolling/context';

export function useUpdateSidebarMenu() {
  const { setViewed } = React.useContext(scrollingContext);
  const dealType = useSelector(selectDealType);
  const hashEstimation = useSelector(getEstimationFiltersHash);
  const isFirstRun = useIsFirstRun();

  /**
   * При смене типа сделки или параметров оценки, помечаем все блоки на странице как не просмотренные
   */
  React.useEffect(() => {
    if (isFirstRun) {
      return;
    }

    setViewed([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setViewed, dealType, hashEstimation]);
}
